import { Tooltip } from "@material-ui/core";
import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import React, { memo, useRef, useState } from "react";
import { observer } from "mobx-react";
import ChatBoxAdviseContent from "./ChatBoxAdviseContent";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import IconEncounterType from "app/common/Icon/IconEncounterType";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
// import {
//   isAdmin,
//   isDoctor,
//   isRoleBranchManager,
//   isRoleChiefTechician,
//   isRoleTechician,
//   isSalesConsultant,
// } from "app/common/LocalFunction";
import HeaderBoxAdvise from "./Component/HeaderBoxAdvise";
import FooterBoxAdvise from "./Component/FooterBoxAdvise";
import { handleUploadMultiple } from "utils";
function ChatBoxAdviseContainer({ handleClose, avatar, displayName, pId }) {
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = pId != null ? pId : urlParams.get("patientId");
  const {
    currentPatientAdvise,
    handleSaveItemAdvise,
    handleGetItemAdviseById,
    openChatBoxAdvise,
    openConfirmDeleteAdviseItem,
    handleConfirmDeleteAdviseItem,
    handleOpenConfirmDialogAdviseItem,
    handleUpdateItemAdviseStatus,
    handleGetPatientOverviewById,
    setSelectedFiles,
    selectedFiles,
    handleGetItemById,
    currentTab: currentTabContainer,
  } = useStore().patientManagementStore.patientGeneralStore;
  const [showDetails, setShowDetails] = useState(true);

  const [currentTab, setCurrentTab] = useState(0);

  const messageEndRef = useRef(null);

  const scrollToBottom = () => {
    messageEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const uploadMultiple = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    let selectedImg = await handleUploadMultiple(files);
    setSelectedFiles([...selectedFiles, ...selectedImg]);
  };

  // let isAdminPermission = isAdmin();
  // let isRoleBranchManagerPermission = isRoleBranchManager();
  // let isSalesConsultantPermission = isSalesConsultant();
  // let isDoctorPermission = isDoctor();
  // let isRoleTechicianPermission = isRoleTechician();
  // let isRoleChiefTechicianPermission = isRoleChiefTechician();

  // const isDeletePermission = isAdminPermission || isRoleBranchManagerPermission;
  // const isEditPermission =
  //   isAdminPermission ||
  //   isRoleBranchManagerPermission ||
  //   isSalesConsultantPermission ||
  //   isDoctorPermission ||
  //   isRoleChiefTechicianPermission ||
  //   isRoleTechicianPermission;

  // const isAddPermission =
  //   isAdminPermission ||
  //   isRoleBranchManagerPermission ||
  //   isSalesConsultantPermission ||
  //   isDoctorPermission ||
  //   isRoleChiefTechicianPermission ||
  //   isRoleTechicianPermission;

  const handleEdit = (item, setValues, values) => {
    let {
      customerConfirmedServices,
      customerInterestedServices,
      customerInterestedProducts,
      customerConfirmedProducts,
      customerInterestedPrepaidCards,
      customerConfirmedPrepaidCards,
      customerInterestedTreatmentCards,
      customerConfirmedTreatmentCards,
      id,
      content,
      lastContent,
      internalContent,
      staff,
    } = item;

    setValues({
      ...values,
      customerConfirmedServices,
      customerInterestedServices,
      customerInterestedProducts,
      customerConfirmedProducts,
      customerInterestedPrepaidCards,
      customerConfirmedPrepaidCards,
      customerInterestedTreatmentCards,
      customerConfirmedTreatmentCards,
      id,
      content,
      lastContent,
      internalContent,
      staff,
    });
    if (item?.dataAttachmentConvert?.length > 0) {
      setSelectedFiles([...item?.dataAttachmentConvert]);
    }
  };

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{ ...currentPatientAdvise }}
        onSubmit={(values) => {
          handleSaveItemAdvise(values);
          scrollToBottom();
        }}
      >
        {({ setFieldValue, values, setValues }) => {
          return (
            <Form>
              <>
                <div
                  className={`chat-container z-1000 ${openChatBoxAdvise ? "open" : "close"
                    }`}
                >
                  {openChatBoxAdvise ? (
                    <>
                      <div className="chat-main">
                        <HeaderBoxAdvise
                          patientId={patientId}
                          handleGetItemAdviseById={handleGetItemAdviseById}
                          handleGetPatientOverviewById={
                            handleGetPatientOverviewById
                          }
                          handleUpdateItemAdviseStatus={
                            handleUpdateItemAdviseStatus
                          }
                          handleClose={handleClose}
                          // isEditPermission={isEditPermission}
                          // isDeletePermission={isDeletePermission}
                          currentTabContainer={currentTabContainer}
                        />

                        <section className="cards-container container-message">
                          {values?.patientAdvice?.items?.length > 0 ? (
                            <ChatBoxAdviseContent
                              items={values?.patientAdvice?.items}
                              handleEdit={(item) => {
                                handleEdit(item, setValues, values);
                              }}
                              disabled={!values?.patientAdvice}
                              handleDelete={handleOpenConfirmDialogAdviseItem}
                              handleGetItemById={handleGetItemById}
                              // isEditPermission={isEditPermission}
                              // isDeletePermission={isDeletePermission}
                              handleSaveItemAdvise={handleSaveItemAdvise}
                            />
                          ) : (
                            <>
                              <span
                                style={{ color: "#333", textAlign: "center" }}
                              >
                                <i>
                                  {values?.patientAdvice
                                    ? "Chưa có tư vấn nào!"
                                    : "Chưa có phiếu tư vấn nào!"}
                                </i>
                              </span>
                            </>
                          )}
                          <div ref={messageEndRef} />
                        </section>
                        <div
                          style={{ textAlign: "center", cursor: "pointer" }}
                          onClick={() => setShowDetails(!showDetails)}
                        >
                          {showDetails ? (
                            <Tooltip title="Thu gọn">
                              <KeyboardArrowDownIcon
                                style={{ fontSize: 20, color: "#4276a4" }}
                              />
                            </Tooltip>
                          ) : (
                            <Tooltip title="Mở rộng">
                              <KeyboardArrowUpIcon
                                style={{ fontSize: 20, color: "#4276a4" }}
                              />
                            </Tooltip>
                          )}
                        </div>
                        <FooterBoxAdvise
                          showDetails={showDetails}
                          setCurrentTab={setCurrentTab}
                          currentTab={currentTab}
                          uploadMultiple={uploadMultiple}
                          selectedFiles={selectedFiles}
                          setSelectedFiles={setSelectedFiles}
                        // isAddPermission={isAddPermission}
                        />
                      </div>
                    </>
                  ) : (
                    <Tooltip title="Tư vấn">
                      <div
                        className="chat-float-button"
                        onClick={() => handleClose(true)}
                      >
                        <IconEncounterType color="white" />
                      </div>
                    </Tooltip>
                  )}
                </div>
                {!!openConfirmDeleteAdviseItem && (
                  <ConfirmPopup
                    open={!!openConfirmDeleteAdviseItem}
                    onClose={() => handleOpenConfirmDialogAdviseItem(false)}
                    text="Bạn có chắc chắn muốn xóa tư vấn này không ?"
                    onConfirm={handleConfirmDeleteAdviseItem}
                  />
                )}
              </>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}

export default memo(observer(ChatBoxAdviseContainer));
